import React, { useState } from 'react';
import UniversalHeader from '../common/UniversalHeader';
import Footer from '../common/Footer';

const PetOwnerLayout = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  return (
    <div className="theme-pet-owner min-h-screen bg-gray-50">
      <UniversalHeader />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PetOwnerLayout; 